import * as React from 'react';

function SvgIconQuestion(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={6} height={8} {...props}>
      <path
        fill="#38B2A6"
        fillRule="evenodd"
        d="M2.316 5.818v-.427c0-.18.013-.342.04-.484a1.732 1.732 0 01.347-.776c.093-.12.211-.248.353-.384l.505-.483c.142-.128.263-.27.364-.428.1-.158.151-.349.151-.574 0-.293-.091-.538-.274-.737-.184-.199-.443-.298-.78-.298a1.11 1.11 0 00-.465.095 1.122 1.122 0 00-.589.636 1.512 1.512 0 00-.09.439L.5 2.273c.045-.36.14-.68.286-.962.146-.281.334-.52.566-.715.232-.195.497-.343.796-.444C2.447.05 2.768 0 3.112 0c.321 0 .626.047.914.14.288.094.542.233.762.417.22.184.394.41.521.68.127.271.191.582.191.935 0 .24-.026.45-.078.63-.053.18-.128.345-.225.495-.097.15-.215.295-.353.434a9.341 9.341 0 01-.465.433c-.15.127-.271.24-.364.337a1.542 1.542 0 00-.225.293 1.031 1.031 0 00-.117.315 2.137 2.137 0 00-.034.417v.292H2.316zm-.15 1.392c0-.221.082-.412.245-.571A.812.812 0 013 6.4c.222 0 .417.076.583.229.167.152.25.339.25.56a.77.77 0 01-.244.572A.812.812 0 013 8a.82.82 0 01-.318-.062.903.903 0 01-.265-.167.774.774 0 01-.183-.249.729.729 0 01-.067-.312z"
      />
    </svg>
  );
}

export default SvgIconQuestion;
